module.exports = __webpack_public_path__ + "static/media/paper-airplane.487d9496.svg";